import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';
import useWindowResize from 'pubweb-smokey/dist/hooks/useWindowResize';
import { formatNumberWithCommas } from 'pubweb-smokey/dist/utils/formatters';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import { LandListingItemStyles } from './LandListingItem.styled';

const LocationMarker = ({ number, selected }) => {
  return (
    <div className="h5 map-marker-area">
      <div className={`map-pin ${selected ? 'selected' : null}`}>
        <div className="map-text">{number}</div>
      </div>
    </div>
  );
};

LocationMarker.propTypes = {
  number: PropTypes.any,
  selected: PropTypes.bool,
};

const LandListingImage = ({ hasImage, ...props }) => {
  return hasImage ? (
    <Image width={133} height={99} {...props} />
  ) : (
    'Image unavailable'
  );
};

LandListingImage.propTypes = {
  hasImage: PropTypes.bool,
};

const LandListingItem = ({ listing, pinNumber, selected, ...props }) => {
  const [showImages, setShowImages] = useState();
  const [hasImage, setHasImage] = useState(true);

  var fullAddress =
    listing.address.street +
    ', ' +
    listing.address.city +
    ', ' +
    listing.address.state +
    ' ' +
    listing.address.zip;

  useWindowResize(() => {
    setShowImages(window.innerWidth > desktop_breakpoint);
  }, [desktop_breakpoint]);

  const handleImageError = () => setHasImage(false);

  return (
    <LandListingItemStyles
      className={
        'listing-item listing-item-' +
        pinNumber +
        ' ' +
        (selected && 'selected')
      }
      {...props}
    >
      <div className="constrained-width">
        <div className="listing-details">
          <div className="listing-header">
            <LocationMarker number={pinNumber} selected={selected} />
            <p>
              <h5 className="listing-price">{listing.listPriceDisplay}</h5>
              <h6 className="listing-broker">{listing.brokerage?.name}</h6>
              <h6 className="listing-broker-mobile">
                <Link href={`/find-land/listings/${listing.listingKey}`}>
                  {listing.brokerage?.name}
                </Link>
              </h6>
            </p>
          </div>
          <span className="listing-address standard">
            {listing.address.street}
            {listing.address.street ? <br /> : null}
            {listing.address.city}
            {listing.address.city && listing.address.state ? ',' : null}{' '}
            {listing.address.state} {listing.address.zip}
          </span>
          <span className="listing-size caption">
            {formatNumberWithCommas(
              parseFloat(listing.lotSize.value).toFixed(2)
            )}{' '}
            {listing.lotSize.lotSizeUnits}
          </span>
        </div>
        <div className="listing-references">
          <div className="listing-thumbnail">
            {showImages && listing.media[0]?.mediaUrl && (
              <LandListingImage
                hasImage={hasImage}
                key={listing.mlsNumber + '-image'}
                alt={`Photo of ${fullAddress}`}
                src={`${listing.media[0].mediaUrl}?w=133`}
                onError={handleImageError}
              />
            )}
          </div>
          <div>
            <Link
              href={`/find-land/listings/${listing.listingKey}`}
              className="xsmall"
            >
              VIEW LAND
            </Link>
          </div>
        </div>
      </div>
    </LandListingItemStyles>
  );
};

LandListingItem.propTypes = {
  listing: PropTypes.shape({
    address: PropTypes.shape({
      city: PropTypes.any,
      state: PropTypes.any,
      street: PropTypes.string,
      zip: PropTypes.any,
    }),
    brokerage: PropTypes.shape({
      name: PropTypes.any,
    }),
    listPriceDisplay: PropTypes.any,
    listingKey: PropTypes.any,
    lotSize: PropTypes.shape({
      lotSizeUnits: PropTypes.any,
      value: PropTypes.any,
    }),
    media: PropTypes.any,
    mlsNumber: PropTypes.string,
  }),
  pinNumber: PropTypes.any,
  selected: PropTypes.bool,
};

export default LandListingItem;
